import { UserInteractiveService } from '@/Services/user-interactive.service';
import { Component, inject, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ModalGenericComponent } from '../modal-generic/modal-generic.component';
import { lastValueFrom } from 'rxjs';
import { AuthService } from '@/Services/auth.service';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss',
})
export class UnauthorizedComponent implements OnInit {
  userInteractiveService = inject(UserInteractiveService);
  authService = inject(AuthService)

  ngOnInit(): void {
    this.onGoToLogin();
  }

  async onGoToLogin() {
    const config: DynamicDialogConfig = { 
        header: `Confirmación`,
        width: '30%',
        style: {'min-width': '350px'},
        data: {
            message: 'Sin permisos para realizar esta acción, comuníquese con el administrador del sistema',
            tipoConfirmacion: 'warning',
            confirmLabel: 'Ok',
        }
    };

    this.userInteractiveService.openDialog(ModalGenericComponent, config);
  }
}
